<template>
    <div id="graph" class="graph">
      <h1>Data Graph</h1>
      <div>
        <div><label for="company">Company</label></div>
        <select name="company" id="company_name" @change="regenerateChart()">
          <option>All</option>
          <option v-for="company in company_names" :key="company.name">{{ company.name }}</option>
        </select>
        <div><label for="year">Year</label></div>
        <select name="year" id="graph_year" @change="regenerateChart()">
          <option v-for="graph_year in graph_years" :key="graph_year.year">{{ graph_year.year }}</option>
        </select>
      </div>
      <div style="overflow: none; max-width: 100%">
          <div id="canvas-wrapper" class="chart-container" style="position: relative; height:55vh">
              <canvas id="chart"></canvas>
          </div>
      </div>
    </div>
</template>

<style lang="scss" scoped>
  .graph{
    margin-top: 2em;
  }
</style>

<script>
  export default {
    name: 'Chart',
    data() {
      return {
        company_names: [],
        graph_years: [],
        name: [],
        v1: [],
        v2: [],
        v3: [],
        v4: [],
        v5: [],
        v6: [],
        v7: [],
        v8: [],
        imvm: []
      }
    },
    mounted: function(){
        this.getAllCompanyNames();
				this.getAllYears();

				let year = 2017;
				let company = 'All';

				this.generateChart(year, company);
    },
    methods:{
				getAllCompanyNames: function(){
            let myself = this;
						this.axios.get("php/api.php?action=names").then(function(response){
                //myself.company_names = [{"name":"Audi AG"},{"name":"BMW"},{"name":"Daimler Group"},{"name":"FCA"},{"name":"Ford"},{"name":"GM"},{"name":"Honda "},{"name":"Hyundai"},{"name":"Nissan"},{"name":"PSA"},{"name":"Renault"},{"name":"Toyota"}];
								myself.company_names = response.data;
						});
				},
				getAllYears: function(){
            let myself = this;
						this.axios.get("php/api.php?action=years").then(function(response){
                //this.graph_years = [{"year":2017},{"year":2016},{"year":2015},{"year":2014},{"year":2013},{"year":2012},{"year":2011},{"year":2010},{"year":2009},{"year":2008}];
								myself.graph_years = response.data;
						});
				},
				regenerateChart: function () {
					let company = $("#company_name option:selected").val();
					let year = $("#graph_year option:selected").val();

					this.generateChart(year, company);

				},
				generateChart: function(year, company) {
						let chart = document.getElementById('chart').getContext('2d');

						$.ajax({
								url: "php/graph.php?year=" + year + "&company=" + company,
								method: "GET",
								success: function(data) {
                    //let data = [{Name: "Audi AG", V1: 1.072, V2: 1.604, V3: 1.185, V4: 2, V5: 1.21, V6: 1.75, V7: 1.547, V8: 1.618}];
										this.name = [];
										this.v1 = [];
										this.v2 = [];
										this.v3 = [];
										this.v4 = [];
										this.v5 = [];
										this.v6 = [];
										this.v7 = [];
										this.v8 = [];
                    this.imvm = [];

										for(var i in data) {
												this.name.push(data[i].Name);
												this.v1.push(data[i].V1);
												this.v2.push(data[i].V2);
												this.v3.push(data[i].V3);
												this.v4.push(data[i].V4);
												this.v5.push(data[i].V5);
												this.v6.push(data[i].V6);
												this.v7.push(data[i].V7);
												this.v8.push(data[i].V8);
                        this.imvm.push(data[i].IMVM);
										}

										var chartdata = {
												labels: this.name,
												datasets : [
														{
																label:'V1\'',
																data: this.v1,
																borderColor: "#466999",
																backgroundColor: "#7394c9"
														},
														{
																label:'V2\'',
																data: this.v2,
																borderColor: "#b06523",
																backgroundColor: "#e0974f"
														},
														{
																label:'V3\'',
																data: this.v3,
																borderColor: "#588a2f",
																backgroundColor: "#85ba5d"
														},
														{
																label:'V4\'',
																data: this.v4,
																borderColor: "#a13032",
																backgroundColor: "#d15e60"
														},
														{
																label:'V5\'',
																data: this.v5,
																borderColor: "#515757",
																backgroundColor: "#7f8585"
														},
														{
																label:'V6\'',
																data: this.v6,
																borderColor: "#603b78",
																backgroundColor: "#8f67a6"
														},
														{
																label:'V7\'',
																data: this.v7,
																borderColor: "#7d3b2a",
																backgroundColor: "#ab6857"
														},
														{
																label:'V8\'',
																data: this.v8,
                                borderColor: "#9e9447",
																backgroundColor: "#ccc274"
														},
                            {
                                label:'Imvm',
                                data: this.imvm,
                                borderColor: "#0E6655",
                                backgroundColor: "#138D75"
                            }
												]
										};

										$("#canvas-wrapper").html("").html('<canvas id="chart"></canvas>');

										var ctx = $("#chart");

										var barGraph = new Chart(ctx, {
												type: 'bar',
												data: chartdata,
												options:{
														title:{
										            display: true,
										            text: company + " - " + year
										        },
														responsive: true,
														maintainAspectRatio: false,
														animation: {
																duration: 500,
														},
														hover: {
																animationDuration: 1000,
														},
														responsiveAnimationDuration: 200,
														background: 'rgba(50,50,255,.5)',
														scales: {
																yAxes: [{
																		ticks: {
																				beginAtZero:true
																		}
																}]
														}
												}
										});
								},
								error: function(data) {
										console.log(data);
								}
						});

						//chart.update();
				}
    }
  }
</script>
